import baseFetch, { createParamString } from '../baseFetch';

// eslint-disable-next-line import/prefer-default-export
export const fetchPromoBoxSlides = async (limit = 7, cookies) =>
  baseFetch(`/feed/promobox?${createParamString({ limit })}`, { cookies });
